import axios from 'axios';

import { CapabilityStatus, CapabilityType } from '../common/types/enums';
import { sdkSearchApiEndpoint } from '../config/endpoints';

interface ISearchWithIntentRequest {
  searchText: string;
}

export interface ISearchWithIntentResponse {
  matches: Array<{ similarityScore: number; result: SearchResultsResponse }>;
}

interface SearchResultsResponse {
  metadata: {
    blockId: string;
    blockVersion: string;
    capabilityId: string;
    capabilityVersion: string;
    minArtifactVersion: string;
    maxArtifactVersion: string;
    capabilityStatus: CapabilityStatus;
    capabilityType: CapabilityType;
  };
  content: {
    output?: any;
    handler?: any;
    input?: any;
    description?: string;
    capabilityName?: string;
  };
}

export async function searchWithIntent(request: ISearchWithIntentRequest) {
  const response = await axios.post<ISearchWithIntentResponse>(
    `${sdkSearchApiEndpoint}/search-capability-with-intent`,
    {
      ...request,
      capabilityTypeList: [CapabilityType.FUNCTION],
    },
  );
  return response.data;
}
